import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import SvgIconLocal from './Svg/SvgIcon';
import './IconHolder.scss';

export default function IconHolder(props) {

  const { icon, viewBox, fontSize, local } = props;
  const vb = viewBox || "0 0 45 45";

  return (
    <div className="d-flex justify-content-center align-items-center icon-wrap icon-holder-wrapper">
      {local
        ? <SvgIconLocal iconName={icon} color="primary" fontSize={fontSize} viewBox={vb} />
        : <SvgIcon component={icon} color="primary" fontSize={fontSize} viewBox={vb} />
      }

    </div>
  )
}

IconHolder.propTypes = {
  icon: PropTypes.any.isRequired,
  viewBox: PropTypes.string,
}
